import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { logout } from "../../actions/auth/auth";

export default function Logout() {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();
  useEffect(() => {
    async function logoutAction() {
      await dispatch(logout());
      await enqueueSnackbar("Logout success", {
        variant: "success",
      });
      history.push("/");
    }
    logoutAction();
  }, []);
  return <div></div>;
}